import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { Subject } from 'rxjs/internal/Subject';
import { filter, map, takeUntil } from 'rxjs';

let COUNTER = 0;

@Component({
  selector: 'wr-more-menu',
  standalone: false,
  templateUrl: './more-menu.component.html',
  styleUrl: './more-menu.component.scss'
})
export class MoreMenuComponent implements OnInit, OnDestroy{
  @Input() items: NbMenuItem[] = [];
  @Output() select = new EventEmitter<NbMenuItem>();

  private destroy$ = new Subject<void>();
  private tag = `wr-more-menu-${++COUNTER}`;

  constructor(private menu: NbMenuService) {}

  ngOnInit() {
    this.menu.onItemClick()
      .pipe(
        takeUntil(this.destroy$),
        filter(({ tag }) => tag === this.tag),
        map(({ item }) => item as NbMenuItem),
      )
      .subscribe(item => this.select.emit(item));
  }

  get contextTag() { return this.tag; }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
